import { render, staticRenderFns } from "./TabWallpapers.vue?vue&type=template&id=6ecc86f8&scoped=true&"
import script from "./TabWallpapers.vue?vue&type=script&lang=js&"
export * from "./TabWallpapers.vue?vue&type=script&lang=js&"
import style0 from "./TabWallpapers.vue?vue&type=style&index=0&id=6ecc86f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecc86f8",
  null
  
)

export default component.exports